module.exports = __webpack_public_path__ + "img/premium-membership.513d7c70.svg";